import enIntl from "./en";
import frIntl from "./fr";
import deIntl from "./de";

export { enIntl, frIntl, deIntl };
